// extracted by mini-css-extract-plugin
export default {"botao":"Botao_botao__C5GzN","botaoDestacado":"Botao_botaoDestacado__qqy9k"};